import React, { useState } from "react";
import axios from "axios";
import AlvnaBrand from "../components/AlvnaBrand";
import { endpoints } from "../apiConfig";
import { colors, fonts, space, radius, buttonPrimary, inputBase } from "../theme";

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("This reset link is missing its token. Please use the link from your email exactly as sent.");
      return;
    }
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    try {
      await axios.post(endpoints.resetPassword, { token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong. This link may have expired.");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <AlvnaBrand variant="full" />
        {success ? (
          <div style={{ padding: space[5], textAlign: "center" }}>
            <h2 style={styles.heading}>Password updated</h2>
            <p style={{ fontFamily: fonts.body, color: colors.textSecondary }}>
              You can now log in with your new password.
            </p>
            <a href="/login" style={styles.link}>Go to Login</a>
          </div>
        ) : (
          <form onSubmit={submit} style={styles.form}>
            <h2 style={styles.heading}>Set a New Password</h2>
            {!token && (
              <div style={styles.error}>
                No reset token found in this link. Please open the link from your email again.
              </div>
            )}
            {error && <div style={styles.error}>{error}</div>}
            <input
              style={styles.input}
              type="password"
              placeholder="New password (min 8 characters)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <input
              style={styles.input}
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
            <button style={styles.button} type="submit">Update Password</button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: colors.bgPage,
    padding: space[4],
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: 380,
    background: colors.surface,
    borderRadius: radius.lg,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    overflow: "hidden",
  },
  form: { display: "flex", flexDirection: "column", gap: space[3], padding: space[5] },
  heading: { margin: "0 0 4px", fontFamily: fonts.display, fontSize: 19, fontWeight: 600, textAlign: "center", color: colors.textPrimary },
  input: inputBase,
  button: buttonPrimary,
  error: { color: "#b91c1c", fontSize: 13, textAlign: "center", fontFamily: fonts.body },
  link: { color: colors.brandBlue, fontWeight: 600, textDecoration: "none", fontFamily: fonts.body },
};
